import './vendor/jquery.overlaps';

class Whiteboard {

    constructor() {

    }

    init() {

        this.container = $('.jsWhiteBoardContainer');

        this.checkOverLapping();
        this.setContainerHeight();

        $(window).on('resize', () => {
            this.checkOverLapping(true);
            this.setContainerHeight();
        });

        $(window).on('load', () => {
            this.setContainerHeight();
        });
    }

    checkOverLapping(reset) {

        return;

        // reset all margis
        if(reset) {
            $('.jsWhiteBoardItem').css('margin-top', 0);
        }

        // if whiteboard items overlap
        let overlapping = $('.jsWhiteBoardItem').overlaps();
        if(overlapping.length > 0) {

            // find most top positioned element
            let mostTopEl = null;
            overlapping.each((index, el) => {
                if(mostTopEl == null || mostTopEl.position().top > $(el).position().top) {
                    mostTopEl = $(el);
                }
            });

            // loop over overlapping elements
            overlapping.each((index, el) => {
                // skip most top
                if($(el).data('id') != mostTopEl.data('id')) {
                    // apply top margin until the element is no more overlapping
                    this.moveDown($(el));
                }
            });

            return overlapping;
        }
    }

    moveDown(obj) {

        let counter = 0;
        while (this.isOverlapping(obj) && counter < 1000) {
            obj.css('margin-top', '+=1');
            counter++;
        }
    }

    isOverlapping(obj) {
        let result = false;
        let overlapping = $('.jsWhiteBoardItem').overlaps();
        overlapping.each((index, el) => {
            if($(el).data('id') == obj.data('id')) {
                result = true;
                return;
            }
        });
        return result;
    }

    setContainerHeight() {
        let maxTopPosition = 0;
        $('.jsWhiteBoardItem').each((index, el) => {
            let obj = $(el);
            let top = obj.position().top;
            let height = obj.outerHeight();
            let marginTop = parseInt(obj.css('margin-top'));
            let thisMaxTopPosition = top + height + marginTop;
            if(thisMaxTopPosition > maxTopPosition) {
                console.log(obj.data('id'));
                maxTopPosition = thisMaxTopPosition;
            }
        });
        this.container.height(maxTopPosition);
    }
}

export default Whiteboard;